import type { OwnerTrialView } from '@/types/backend'
import { computeTrial } from '@/lib/trial'
import { Link } from 'react-router-dom'

export function TrialBanner({ owner }: { owner: OwnerTrialView }) {
  const t = computeTrial(owner)
  if (owner.planStartedAt || t.state === 'NO_TRIAL') return null

  if (t.state === 'ACTIVE') {
    return (
      <div className='rounded-xl  mb-4 border border-amber-200 bg-amber-50 p-4'>
        <div className='flex items-start justify-between gap-3'>
          <div>
            <div className='font-semibold text-amber-900'>
              Période d’essai en cours
            </div>
            <div className='text-sm text-amber-800'>
              Il vous reste <b>{t.daysLeft} jours</b>. Conservez les relances et
              quotas après l’essai.
            </div>
            <div className='mt-3 h-2 w-full rounded bg-amber-100'>
              <div
                className='h-2 rounded bg-amber-500'
                style={{ width: `${t.pct}%` }}
              />
            </div>
            <div className='mt-1 text-xs text-amber-700'>
              {t.pct}% du quota utilisé
            </div>
          </div>
          <Link
            to='/pricing'
            className='rounded-lg bg-amber-600 px-3 py-2 text-sm font-semibold text-white hover:bg-amber-700'
          >
            Activer un plan
          </Link>
        </div>
      </div>
    )
  }

  return (
    <div className='rounded-xl border border-rose-200 bg-rose-50 p-4'>
      <div className='flex items-start justify-between gap-3'>
        <div>
          <div className='font-semibold text-rose-900'>Essai expiré</div>
          <div className='text-sm text-rose-800'>
            Activez un plan pour continuer à envoyer des messages et relances.
          </div>
        </div>
        <Link
          to='/pricing'
          className='rounded-lg bg-rose-600 px-3 py-2 text-sm font-semibold text-white hover:bg-rose-700'
        >
          Voir les offres
        </Link>
      </div>
    </div>
  )
}
